var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41398 14.3733C8.18732 14.4533 7.81398 14.4533 7.58732 14.3733C5.65398 13.7133 1.33398 10.96 1.33398 6.29332C1.33398 4.23332 2.99398 2.56665 5.04065 2.56665C6.25398 2.56665 7.32732 3.15332 8.00065 4.05998C8.67398 3.15332 9.75399 2.56665 10.9607 2.56665C13.0073 2.56665 14.6673 4.23332 14.6673 6.29332C14.6673 10.96 10.3473 13.7133 8.41398 14.3733Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.b685c866f4a1461ab0b22e3110407680.svg";
export { ForwardRef as ReactComponent };